import { render, staticRenderFns } from "./MetricRecordView.vue?vue&type=template&id=2557b160"
import script from "./MetricRecordView.vue?vue&type=script&lang=js"
export * from "./MetricRecordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports